import { get, post } from './../Client/BaseClient';

export const AuthenticationApi = {
    Login: (param) =>
        post('Login', param),
    Logout: (id) =>
        get(`Logout/?userId=${id}`),
};